import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid, Link } from "@mui/material";
import { experienceKeys } from "@src/api/queryKeys";
import { PERSONALIZATION_ROUTES } from "@src/routes/routes";
import { useQueryClient } from "@tanstack/react-query";

interface DiscountSyncErrorToastProps {
  onClick: (ev: React.MouseEvent) => void;
}

// eslint-disable-next-line react-refresh/only-export-components
const DiscountSyncErrorToast = ({ onClick }: DiscountSyncErrorToastProps) => {
  return (
    <Grid container direction={"column"} onClick={onClick}>
      <Grid item>
        <IgTypography igStyle={"semibold"}>
          Discount Synchronization Error
        </IgTypography>
      </Grid>
      <Grid item>
        <IgTypography>
          Go to <Link sx={{ cursor: "pointer" }}>Experiences</Link> to correct
          the error.
        </IgTypography>
      </Grid>
    </Grid>
  );
};

export function useDiscountSyncErrorToast() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const ref = useRef<"success" | "error">(undefined);

  return (status: "success" | "error") => {
    const oldStatus = ref.current;
    if (status !== oldStatus) {
      ref.current = status;
      if (status === "error") {
        if (
          window.location.pathname !== PERSONALIZATION_ROUTES.Personalizations
        ) {
          const onClick = () => {
            void navigate(PERSONALIZATION_ROUTES.Personalizations);
            toast.dismiss("DiscountSyncError");
          };
          toast.error(<DiscountSyncErrorToast onClick={onClick} />, {
            toastId: "DiscountSyncError",
            autoClose: 20000,
            closeOnClick: false,
          });
        }
      } else {
        toast.info("Discount Synchronization Error Resolved");
      }
      void queryClient.invalidateQueries({
        queryKey: experienceKeys.personalizationList,
      });
    }
  };
}
